import React from "react";
import styled from "styled-components";
import { API_ROOT, checkStatus, parseJSON, colors } from "../util/constants";
import NewInput from "./FormComponents/NewInput";
import NewButton from "./FormComponents/NewButton";

class OTPVerification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: 0,
      number: props.number,
      redirect: props.redirect,
      error: false,
      errorText: "",
      processing: false,
      resending: false
    };
  }

  handleOTP = e => {
    this.setState({
      otp: e.target.value
    });
  };

  otpSubmit = event => {
    event.preventDefault();
    this.setState({ processing: true });
    var myRequestUrl = API_ROOT + "verifyotp.php";
    var formData = new FormData();

    formData.append("otp", this.state.otp);
    formData.append("number", this.props.number);
    formData.append("countryCode", this.props.countryCode);
    var self = this;

    fetch(myRequestUrl, {
      method: "POST",
      body: formData,
      credentials: "same-origin"
    })
      .then(checkStatus)
      .then(parseJSON)
      .then(function(data) {
        if (data.status) {
          // document.cookie = "userCookieId=" + res.uid + ";path=/";
          window.location.href = self.props.redirect;
        } else {
          self.setState({
            error: true,
            errorText: "Invalid OTP. Please enter correct OTP.",
            processing: false
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  resendOTP = () => {
    var myRequestUrl = API_ROOT + "resendotp.php";
    var formData = new FormData();
    this.setState({ resending: true });

    formData.append("number", this.state.number);
    formData.append("countryCode", this.props.countryCode);

    var self = this;

    fetch(myRequestUrl, {
      method: "POST",
      body: formData,
      credentials: "same-origin"
    })
      .then(checkStatus)
      .then(parseJSON)
      .then(function(data) {
        self.setState({ resending: false });
      })
      .catch(function(error) {
        console.log(error);
      });
  };
  render() {
    return (
      <Container>
        <SentTo>
          An otp has been sent to :{" "}
          {"+" + this.props.countryCode + this.props.number}
        </SentTo>

        <form className="signupForm" onSubmit={this.otpSubmit}>
          <NewInput
            type="text"
            required={true}
            autoComplete="off"
            placeholder="Type OTP received here.."
            autofocus={true}
            maxLength={4}
            onChange={this.handleOTP}
            margin="0 0 10px"
          />
          <NewButton block type="submit" disabled={this.state.processing}>
            {this.state.processing ? "Verifying.." : "Verify"}
          </NewButton>
          {this.state.error && <ErrorText>{this.state.errorText}</ErrorText>}
          <NewButton
            block
            type="button"
            secondary
            onClick={this.resendOTP}
            border="1px solid #a0a0a0"
            disabled={this.state.resending}
          >
            {this.state.resending ? "Resending.." : "Resend OTP"}
          </NewButton>
        </form>
      </Container>
    );
  }
}
const Container = styled.div`
  width: 90%;
  max-width: 400px;
  padding: 2rem 1rem;
  border-radius: 3px;
  background-color: #ffffff;

  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
`;
const SentTo = styled.p`
  margin: 0 0 10px;
  font-size: 16px;
`;
const ErrorText = styled.p`
  font-size: 16px !important;
  font-weight: 500 !important;
  color: ${colors.error} !important;
  margin: 10px 0 !important;
  padding: 0 !important;
  text-align: center !important;
`;
export default OTPVerification;



// WEBPACK FOOTER //
// ./src/components/OTPVerification.js